// Подключает общий пакет таблиц к приложению: свои базовые компоненты, язык и ключи хранилища.

import { DEFAULT_TABLE_STORAGE_KEYS } from "@cherserg/table";
import { defaultTableUrlAdapter, TableProvider, type TableComponents } from "@cherserg/table/react";
import type { ReactNode } from "react";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { EmptyState } from "./ui/empty-state";
import { ErrorState } from "./ui/error-state";
import { Loading } from "./ui/loading";
import { Modal } from "./ui/modal";
import { Select } from "./ui/select";

const TABLE_COMPONENTS: TableComponents = {
  Button,
  Modal,
  Select,
  Badge,
  EmptyState,
  Loading,
  ErrorState,
};

export function AppTableProvider({ children }: { children: ReactNode }) {
  return (
    <TableProvider
      locale="en-US"
      storageKeys={DEFAULT_TABLE_STORAGE_KEYS}
      components={TABLE_COMPONENTS}
      urlAdapter={defaultTableUrlAdapter}
    >
      {children}
    </TableProvider>
  );
}
